
class Postgrest {
  // public postgrestAddress: string = "https://www.testbed.gr/postgrest";  
  public postgrestAddress: string = "https://postgrest.cmms-lass.com";  

  //this.$store.getters.getConnectionSettings
  //"https://www.testbed.gr/postgrest/";
  //https://server_ip/postgrest/
  //"http://localhost:3000";
  //https
  ///postgrest
  //testbed.gr
  //54.171.62.112
  // TODO: Error handling
  public Postgrest() {
    

  }

  public SetHost(host: string){
    this.postgrestAddress = host
  }

  private async parseJsonSafe(res: Response): Promise<any> {
    const rawBody = await res.text();
    if (!rawBody) {
      return {};
    }
    try {
      return JSON.parse(rawBody);
    } catch (_err) {
      return { message: rawBody };
    }
  }

  public async get(request: string, token: string): Promise<any> {
    console.log(this.postgrestAddress);
    console.log(request);
    let url: string = `${this.postgrestAddress}/${request}`;
    let res: any = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
         Authorization: "Bearer " + token,
      },
    });

    const payload = await this.parseJsonSafe(res);
    if (!res.ok) {
      throw new Error(`PostgREST GET ${request} failed: ${res.status} ${res.statusText} ${JSON.stringify(payload)}`);
    }

    return payload;
  }

  public async post(request: string, token: string, body: any): Promise<any> {
    let url: string = `${this.postgrestAddress}/${request}`;
    let res: any = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(body),
    });

    console.log(res.status);
    if(res.status == 201){
      return {}
    }
    const payload = await this.parseJsonSafe(res);
    if (!res.ok) {
      throw new Error(`PostgREST POST ${request} failed: ${res.status} ${res.statusText} ${JSON.stringify(payload)}`);
    }
    return payload;
  }

  public async patch(request: string, token: string, body: any): Promise<any> {
    let url: string = `${this.postgrestAddress}/${request}`;
    let res: any = await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: body,
    });
    console.log(res.status);
    if(res.status == 204){
      return {}
    }
    const payload = await this.parseJsonSafe(res);
    if (!res.ok) {
      throw new Error(`PostgREST PATCH ${request} failed: ${res.status} ${res.statusText} ${JSON.stringify(payload)}`);
    }
    return payload;
  }

  
  public async delete(request: string, token: string): Promise<any> {
    let url: string = `${this.postgrestAddress}/${request}`;
    let res: any = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    console.log(res.status);
    if(res.status == 204){
      return {}
    }
    const payload = await this.parseJsonSafe(res);
    if (!res.ok) {
      throw new Error(`PostgREST DELETE ${request} failed: ${res.status} ${res.statusText} ${JSON.stringify(payload)}`);
    }
    return payload;
  }

}

export const postgrest = new Postgrest();
